export const REGIONS = {
  AP: 'AP',
  US: 'US',
};

export const MARKET_REGIONS_US = [
  {
    name: 'West',
    value: 'west',
    localizationSlug: 'WEST',
  },
  {
    name: 'Midwest/Gulf/Canada',
    value: 'midwest/gulf/canada',
    localizationSlug: 'MIDWEST_GULF_CANADA',
  },
  {
    name: 'Southeast',
    value: 'southeast',
    localizationSlug: 'SOUTHEAST',
  },
  {
    name: 'Northeast',
    value: 'northeast',
    localizationSlug: 'NORTHEAST',
  },
];
